module.exports = __webpack_public_path__ + "static/media/circle-cropped.bd52385f.png";